module.exports = __webpack_public_path__ + "static/media/Moshi-ads.a65efca5.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/Moshi-ads.png
// module id = 370
// module chunks = 0